import type {JSX} from 'react'

import {Navigate} from 'react-router'

import {loggedIn, logout} from '../actions'
import {AppRoutes} from '../App'
import {authFormContainerId, useAuth0Lock} from '../auth/auth0'
import {useAppDispatch, useAppSelector} from '../hooks'
import type {RootState} from '../store'
import {useErrorNotifications} from "./common/Notifications";

interface AuthResult {
  idToken: string
}

export function AuthenticatedLogin(): JSX.Element {
  const dispatch = useAppDispatch()
  const isAuthorized = useAppSelector<boolean>(state => state.user.claims?.isAuthorized ?? false)
  useErrorNotifications((state) => state.auth.error)

  if (isAuthorized) {
    return <Navigate to={AppRoutes.home}/>
  }

  function onLogoutButtonPress() {
    dispatch(logout())
  }

  return (
    <div className='container'>
      <h2>Koka Suunnittelukone</h2>
      <p>Pääset aloittamaan suunnittelun heti, kun Koka on lisännyt sinut järjestelmään.</p>
      <button className='btn btn-primary' onClick={() => onLogoutButtonPress()}>Kirjaudu uudestaan</button>
      <div id={authFormContainerId}/>
    </div>
  )
}

export default function Login(): JSX.Element {
  const dispatch = useAppDispatch()
  const lock = useAuth0Lock(onAuthenticated, onAuthorizationError)

  const isAuthenticated = useAppSelector<boolean>(state => state.user.isAuthenticated)
  const loggedOut = useAppSelector((state: RootState) => !state.auth.token)

  console.log('Login', {isAuthenticated, loggedOut})

  if (isAuthenticated) {
    return <AuthenticatedLogin/>
  }

  function onAuthenticated(authResult: AuthResult): void {
    console.info('Authenticated')
    dispatch(loggedIn({token: authResult.idToken}))
    if (lock) {
      lock.hide()
    }
  }

  function onAuthorizationError(err: string): void {
    console.error('Failed login: ', err)
  }

  return <LoginContainer/>
}

/* Child-components */

function LoginContainer(): JSX.Element {
  useErrorNotifications((state) => state.auth.error)
  useErrorNotifications((state) => state.user.claimsError)

  return (
    <div className='container' data-testid='login-container'>
      <h2>Koka Suunnittelukone</h2>
      <p>
        Tervetuloa Kokan suunnittelukoneeseen. Tämä sivusto on tarkoitettu talotekniikka-alan suunnittelijoiden
        käyttöön. Aloita käyttö rekisteröitymällä tai kirjautumalla sisään alla olevasta painikkeesta.
        Jos olet käyttämässä suunnittelukonetta ensimmäistä kertaa niin Koka Oy hyväksyy ensin tilisi ja pääset heti sen
        jälkeen eteenpäin.
      </p>
      <div id={authFormContainerId} data-testid='login-form'/>
    </div>

  )
}
